export default "__VITE_ASSET__cc459536__"